import 'bootstrap';
import '../scss/app.scss';

import Banners from './modules/Banners';
import Countdown from './modules/Countdown';
import { WOW } from 'wowjs';
import Sharer from 'sharer.npm.js';
import './vendor/jquery-textfill';

$(function() {
  const page = document.body.classList[0];
  switch (page) {
    case 'home':
      if ($('section#banners').length) {
        Banners.init();
      }
      Countdown.init('2018-05-25T01:00', '#countdown');
      break;
    default:
      break;
  }
  $('.testimonial-textfill').textfill({
    maxFontPixels: 36,
  });
  new WOW().init();
  $('#carousel-videos .carousel-control-next,#carousel-videos .carousel-control-prev').on('click', function() {
    const carouselItem = $(this).closest('.carousel-item');
    const iframeCopy = carouselItem.find('iframe').clone();
    carouselItem.find('iframe').remove();
    carouselItem.find('.embed-responsive').append(iframeCopy);
  });
  $('.navbar-collapse').on('show.bs.collapse', function() {
    $(this)
      .closest('.navbar')
      .addClass('dark');
  });
  $('.navbar-collapse').on('hidden.bs.collapse', function() {
    $(this)
      .closest('.navbar')
      .removeClass('dark');
  });
  $('.sharer').on('click', function() {
    $(this).attr('data-url', window.location.href);
    const sharer = new Sharer(this);
    sharer.share();
  });
  $('#privacy-check').on('change', function() {
    if ($(this).prop('checked')) {
      $(this)
        .closest('form')
        .find('button[type="submit"]')
        .removeAttr('disabled');
    } else {
      $(this)
        .closest('form')
        .find('button[type="submit"]')
        .attr('disabled', 'disabled');
    }
  });
});



// WEBPACK FOOTER //
// ./client_src/js/app.js